import { useState } from "react";

const ReadMoreText = ({ text = "", maxLength = 120, className = "" }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) return null;

  const isLong = text.length > maxLength;
  const displayText = isExpanded ? text : text.slice(0, maxLength);

  return (
    <span className={className}>
      {displayText}
      {!isExpanded && isLong && "... "}
      {isLong && (
        <span
          onClick={() => setIsExpanded(!isExpanded)}
          style={{ color: "#2148c0", cursor: "pointer" }}
        >
          {isExpanded ? "Read Less" : "Read More"}
        </span>
      )}
    </span>
  );
};

export default ReadMoreText;
